import styles from './NavigationDrawer.module.css';
import { useSelector } from 'react-redux';
import { routes } from './navigationRoutes';
import MenuIcon from '@mui/icons-material/Menu';
import { selectActiveTab, selectShowRealTimeUpdateMessages } from 'store/transactionsSlice/transactionsSelectors';
import UserNavigation from './userNavigation/UserNavigation';
import RealTimeUpdateVideoWall from 'components/transaction/components/panels/videoWallPanel/RealTimeUpdateVideoWall/RealTimeUpdateVideoWall';
import { useState } from 'react';
import { Drawer, IconButton, List } from '@mui/material';
import { getAvailableRoutes } from './navigationUtils';
import { useNavigate } from 'react-router-dom';

function MainNavigation({ user }) {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const navigate = useNavigate();
    const toggleDrawerOpenHandler = () => setDrawerOpen((state) => !state);
    const isTransactionPageActive = !!useSelector(selectActiveTab);
    const showRealTimeUpdateVideoWall = useSelector(selectShowRealTimeUpdateMessages);
    const showMessage = showRealTimeUpdateVideoWall && isTransactionPageActive;

    const availableRoutes = getAvailableRoutes(routes, user, toggleDrawerOpenHandler);

    return (
        <>
            <div className={styles.navigation}>
                <div className={styles['menu']}>
                    <IconButton onClick={toggleDrawerOpenHandler}>
                        <MenuIcon sx={{ color: 'white' }} />
                    </IconButton>
                    <img
                        alt="AIQ Icon"
                        className={styles['aiq-icon']}
                        src="AIQnavbaricon.png"
                        onClick={() => {
                            navigate('/all-desks');
                        }}
                        style={{ cursor: 'pointer' }}
                    />
                </div>

                <p className={isTransactionPageActive ? styles['reaload-warning'] : styles.hidden}>Refreshing page will reload all streams</p>
                <Drawer className={styles.navigationDrawerContainer} anchor="left" open={drawerOpen} onClose={toggleDrawerOpenHandler}>
                    <List className={styles.navigationDrawer} sx={{ paddingTop: 'var(--header__height--main)' }}>
                        {availableRoutes}
                    </List>
                </Drawer>
                <UserNavigation user={user} isTransactionPageActive={isTransactionPageActive} />
            </div>
            <RealTimeUpdateVideoWall show={showMessage} />
        </>
    );
}

export default MainNavigation;
